import React from 'react';
import DataTable from '../../../widgets/data-table/DataTable/DataTable';
import PropTypes from 'prop-types';
import * as _ from 'lodash-es';
import './SelectBranchesPage.css';
import { Button } from '@material-ui/core';
import { injectIntl } from 'react-intl';
import { intlText } from '../../../../utils/text-util';

const SelectBranchesPage = (props) => {
  const columns = [
    {
      header: {
        display: intlText(props, 'branch_code')
      },
      accessor: (branch) => ({
        display: branch.branchName
      })
    },
    {
      header: {
        display: intlText(props, 'branch_description')
      },
      accessor: (branch) => ({
        display: branch.branchDesc
      })
    }
  ];

  const getBranches = (shouldGetSelected) =>
    _.sortBy(props.selectableBranches, 'branchDesc')
      .filter((branch) => branch.selected === shouldGetSelected)
      .map((branch) => ({
        ...branch,
        onClick: () => props.onBranchSelected(branch)
      }));

  return (
    <div className="row">
      {/* All branches table */}
      <div className="col-xs-12 col-md-4 col-md-offset-1 selectable">
        <h3>{intlText(props, 'available_branches')}</h3>
        <DataTable columns={columns} bodyData={getBranches(false)} />
      </div>

      {/* Selected branches table */}
      <div className="col-xs-12 col-md-4 col-md-offset-1 selectable">
        <h3>{intlText(props, 'selected_branches')}</h3>
        <DataTable columns={columns} bodyData={getBranches(true)} />
        <br />
        <div>
          <div className="btn-action btn-back">
            <Button onClick={props.onClearBranches}>
              {intlText(props, 'action.clear')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

SelectBranchesPage.propTypes = {
  selectableBranches: PropTypes.arrayOf(PropTypes.object.isRequired),
  onBranchSelected: PropTypes.func.isRequired,
  onClearBranches: PropTypes.func.isRequired
};

export default injectIntl(SelectBranchesPage);
